import { Map } from 'immutable';
import { constants as deviceRdcConstants } from '@saucelabs/sl-module-devices-rdc';

import { LS_LAST_DATACENTER_ID, SET_DATACENTER_ID } from './../constants';

const initialState = Map({
  // TODO: Move localStorage access to an operation (during re-ducks refactoring)
  lastDataCenterId: window.localStorage.getItem(LS_LAST_DATACENTER_ID) ||
    deviceRdcConstants.INITIAL_DATACENTER_ID,
});

const rdcDevicePickerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DATACENTER_ID:
      // TODO: Move localStorage access to an operation (during re-ducks refactoring)
      window.localStorage.setItem(LS_LAST_DATACENTER_ID, payload);
      return state.set('lastDataCenterId', payload);
    default:
      return state;
  }
};

export default rdcDevicePickerReducer;
export { initialState };
